export default "__VITE_ASSET__S$Kx8UFB__"